import { useState, useEffect } from "react";
import { useScroll } from "oolib";
export const useFader = (scrollableRef: React.RefObject<HTMLDivElement>) => {
  const [showFader, setShowFader] = useState(false);
  const [showHorizontalFader, setShowHorizontalFader] = useState(false);

  const setFader = () => {
    if (scrollableRef.current) {
      const { scrollTop, scrollHeight, clientHeight, scrollLeft, scrollWidth, clientWidth } = scrollableRef.current;
      
      // Vertical fader logic
      const hasMoreContentToScrollDown = scrollTop + clientHeight < scrollHeight - 5;
      if (hasMoreContentToScrollDown && !showFader) {
        setShowFader(true);
      } else if (!hasMoreContentToScrollDown && showFader) {
        setShowFader(false);
      }
      
      // Horizontal fader logic
      const hasMoreContentToScrollRight = scrollLeft + clientWidth < scrollWidth - 5;
      if (hasMoreContentToScrollRight && !showHorizontalFader) {
        setShowHorizontalFader(true);
      } else if (!hasMoreContentToScrollRight && showHorizontalFader) {
        setShowHorizontalFader(false);
      }
    }
  }

  useEffect(() => {
    setFader()
  }, [])

  useScroll(setFader)

  return { showFader, showHorizontalFader, setFader };
};